module.exports = __webpack_public_path__ + "img/28a775a.png";